module.exports = {
    defaultLanguage: 'es',
    profileColor: {saturation: 60, brightness: 100},
    scssVariables: './src/styles/wave2023',
    defaultPassword: 'default'
}